import React, {Component} from "react";
import LineHaulFilter from "../linehaul/LineHaulFilter";
import LinehaulFilterContextProvider from "../linehaul/context/LineHaulFilterContext";
import InductOverview from "./InductOverview";
import InductArea from "./InductArea";
import Container from "./Container";
import InductOverviewContextProvider from "./context/InductOverviewContext";
import InductAreaContextProvider from "./context/InductAreaContext";
import ContainerContextProvider from "./context/ContainerContext";
import CapabilityContextProvider from "../global/context/ConfigContext";

class Induct extends Component {
    render() {
        return (
            <LinehaulFilterContextProvider>
                <CapabilityContextProvider>
                    <LineHaulFilter context = "induct"/>
                    <InductOverviewContextProvider>
                        <InductOverview/>
                    </InductOverviewContextProvider>
                    <InductAreaContextProvider>
                        <InductArea/>
                    </InductAreaContextProvider>
                    <ContainerContextProvider>
                        <Container/>
                    </ContainerContextProvider>
                </CapabilityContextProvider>
            </LinehaulFilterContextProvider>
        )
    }
}

export default Induct


// WEBPACK FOOTER //
// ./src/components/induct/Induct.js